import React from "react";
import { doNothing } from "@edgetier/utilities";

import { IHeadingMenuContext } from "./heading-menu-context.types";

export const defaultContext: IHeadingMenuContext = { isOpen: false, closeMenu: doNothing };

const HeadingMenuContext = React.createContext<IHeadingMenuContext>(defaultContext);
export default HeadingMenuContext;
